<template>
  <div class="microbiology-filter width-responsiveness">
    <card-form :collapsed="true">
      <div
        slot="expanded"
        class="form-container"
      >
        <md-layout
          :md-gutter="24"
          md-flex="100"
          style="gap: 20px 0"
        >
          <md-layout
            md-flex="100"
            md-flex-medium="100"
          >
            <h2 class="microbiology-filter__title title-main">FILTROS</h2>
          </md-layout>

          <md-layout
            md-flex="45"
            md-flex-medium="50"
          >
            <SearchFieldSelector
              :default-start-date="defaultStartDate"
              :default-end-date="defaultEndDate"
              :options="dateSelectOptions"
              :clean-date="cleanDate"
              @updateSearchValue="handleSearchValueUpdate"
            />
          </md-layout>

          <md-layout
            md-flex="45"
            md-flex-medium="50"
          >
            <SearchFieldSelector
              :options="searchOptions"
              @updateSearchValue="handleSearchValueUpdate"
            />
          </md-layout>

          <md-layout
            md-flex="10"
            md-flex-medium="50"
            class="box-action"
          >
            <button
              :disabled="loading"
              class="btn btn-primary btn-search"
              @click="handleSearch"
            >
              <md-icon
                md-src="/static/images/icon-search.svg"
                class="icon-search"
              >
                search
              </md-icon>
              Buscar
            </button>
          </md-layout>
        </md-layout>
      </div>
    </card-form>
  </div>
</template>

<script>
import CardForm from '@/components/common/CardForm'
import SearchFieldSelector from '@/components/common/SearchFieldSelector'
import Moment from 'moment'
import { LAUDO_PDF_PERIOD_DAYS_DEFAULT } from '@/enums'
import notify from '@/api/notification'

export default {
  name: 'MicrobiologyFilter',
  components: {
    CardForm,
    SearchFieldSelector,
  },
  data() {
    return {
      filter: {
        searchText: '',
        materialName: '',
        examName: '',
        startDate: '',
        endDate: '',
        sortBy: 'date',
      },
      cleanDate: 0,
      loading: false,
      searchOptions: [
        {
          value: 'orderId',
          label: 'OS Alvaro',
          placeholder: 'OS Alvaro',
          type: 'text',
          propName: 'orderId',
          selected: true,
        },
        {
          value: 'orderLisId',
          label: 'OS LIS',
          placeholder: 'OS LIS',
          type: 'text',
          propName: 'orderLisId',
          selected: true,
        },
        {
          value: 'patientName',
          label: 'Nome do Paciente',
          placeholder: 'Nome do paciente',
          type: 'text',
          propName: 'patientName',
          selected: false,
        },
        {
          value: 'examName',
          label: 'Nome do Exame',
          placeholder: 'Nome do exame',
          type: 'text',
          propName: 'examName',
          selected: false,
        },
        {
          value: 'materialName',
          label: 'Material',
          placeholder: 'Nome do Material',
          type: 'text',
          propName: 'materialName',
          selected: false,
        },
      ],
      dateSelectOptions: [
        {
          value: 'date',
          label: 'Período',
          placeholder: 'Período',
          limitDays: 1827,
          singleDate: false,
          selected: true,
          type: 'date',
          propName: 'date',
        },
      ],
    }
  },
  computed: {
    today() {
      return Moment(new Date()).format('DD/MM/YYYY')
    },
    defaultStartDate() {
      return Moment(this.today, 'DD/MM/YYYY')
        .subtract(LAUDO_PDF_PERIOD_DAYS_DEFAULT, 'days')
        .format('DD/MM/YYYY')
    },
    defaultEndDate() {
      return this.today
    },
  },
  created() {
    this.filter.startDate = this.defaultStartDate
    this.filter.endDate = this.defaultEndDate
  },
  methods: {
    handleSearchValueUpdate(value) {
      if (value.type === 'date') {
        this.filter.startDate =
          value.date && value.date.start !== ''
            ? Moment(value.date.start).format('DD/MM/YYYY')
            : ''
        this.filter.endDate =
          value.date && value.date.end !== ''
            ? Moment(value.date.end).format('DD/MM/YYYY')
            : ''
      } else {
        if (value.propName === 'examName') {
          this.filter.materialName = ''
        } else if (value.propName === 'materialName') {
          this.filter.examName = ''
        }
        this.filter[value.propName] = value.query
      }
    },
    handleSortChange() {
      if (this.hasValidFilter()) {
        this.handleSearch()
      }
    },
    handleSearch() {
      if (!this.hasValidFilter()) {
        notify({
          title: 'AVISO:',
          message: 'Por favor, preencha pelo menos um campo de busca.',
        })
        return
      }

      const selectedOption = this.searchOptions.find(opt => opt.selected)
      const searchFilters = {}

      if (this.filter.searchText && selectedOption) {
        searchFilters[selectedOption.propName] = this.filter.searchText
      }

      this.$emit('search', {
        ...searchFilters,
        examName: this.filter.examName,
        materialName: this.filter.materialName,
        startDate: this.filter.startDate,
        endDate: this.filter.endDate,
        sortBy: this.filter.sortBy,
        sort: 'desc',
      })
    },
    hasValidFilter() {
      return (
        this.filter.searchText ||
        this.filter.examName ||
        this.filter.materialName ||
        (this.filter.startDate && this.filter.endDate)
      )
    },
  },
}
</script>

<style lang="scss">
.microbiology-filter {
  margin-top: 25px;
  font-family: 'Exo 2', sans-serif !important;

  .card-form__container {
    border-radius: 8px;
    padding-bottom: 18px;

    .search-field-selector {
      .search {
        .search-field-selector__field {
          input {
            color: #363636;
          }
        }
      }
    }

    .box-action {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-left: 0;
    }

    .btn-search {
      width: 100%;
      max-width: 130px;
      text-transform: uppercase;
      font-family: 'Exo 2', sans-serif !important;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 4px;
      font-size: 14px;
      gap: 4px;

      .md-icon {
        margin: 0;
      }
    }
  }

  &__title {
    color: #363636;
    font-size: 18px;
    font-weight: 600;
    margin: 0;
  }

  &__sort {
    display: flex;
    flex-direction: column;
    width: 100%;

    .sort-label {
      font-size: 12px;
      color: #999;
      margin-bottom: 4px;
      font-weight: 500;
    }

    .sort-select {
      height: 40px;
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 8px;
      font-size: 13px;
      color: #363636;
      background-color: #fff;
      font-family: 'Exo 2', sans-serif;

      &:focus {
        outline: none;
        border-color: #7f1a54;
      }
    }
  }

  .micro-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    &--positive {
      background: #ffe6ee;
      color: #b40048;
      border: 1px solid #f5c5d7;
    }
    &--negative {
      background: #e6f7ff;
      color: #1890ff;
      border: 1px solid #91d5ff;
    }
    &--analyzing {
      background: #fff7e6;
      color: #fa8c16;
      border: 1px solid #ffd591;
    }
  }

  .arrow-toggle {
    color: #7a7a7a;
    display: flex;
    align-items: center;
    .md-icon {
      font-size: 20px;
    }
  }

  .timeline {
    &__bar {
      position: relative;
      height: 10px;
      border-radius: 8px;
      background: #f0f0f0;
      margin: 8px 0 16px;
      overflow: hidden;

      .progress {
        height: 100%;
        background: linear-gradient(
          90deg,
          #2a64ff 0 33%,
          #d8a222 33% 66%,
          #b02a3c 66% 100%
        );
        border-radius: 8px;
        transition: width 0.3s ease;
      }
    }

    &__events {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 12px;
      margin-top: 8px;
    }

    .event {
      position: relative;
      padding-top: 8px;
    }
    .event__date {
      color: #7a7a7a;
      font-size: 11px;
      display: grid;
      grid-template-columns: auto auto;
      column-gap: 6px;
      align-items: baseline;
      margin-bottom: 6px;
      .year {
        opacity: 0.6;
      }
      .day {
        font-weight: 700;
      }
      .time {
        grid-column: 1 / -1;
      }
    }
    .event__marker {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      border: 3px solid #fff;
      box-shadow: 0 0 0 2px #e6e6e6;
      position: absolute;
      top: -18px;
      left: 0;
    }
    .event__marker.start {
      background: #2a64ff;
    }
    .event__marker.partial {
      background: #d8a222;
    }
    .event__marker.final {
      background: #b02a3c;
    }
    .event__content {
      font-size: 12px;
      color: #303030;
    }
    .event .title {
      font-weight: 700;
      margin-bottom: 2px;
    }
    .title--partial {
      color: #d08a00;
    }
    .title--final {
      color: #b02a3c;
    }
    .event a {
      color: #2a64ff;
      text-decoration: underline;
    }
    .event .subtitle {
      color: #7a7a7a;
      font-size: 11px;
      text-transform: uppercase;
    }
    .event .note {
      margin-top: 2px;
    }
  }
}
</style>
